export default "__VITE_ASSET__BHYFPvSc__"